import { ColDef } from 'ag-grid-community';

/** Keeps export fields outside a compact table's display and quick-search inventory. */
export default function mobileExportColumns(columns: ColDef[]): ColDef[] {
  return columns.map((column) => ({ ...column, hide: true, getQuickFilterText: () => '' }));
}
